/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Collapse_Position_StyleInputs */



/**
* | output |
* | --- |
* | "Collapse Position and Caption Style" |
*
* @param {Options_Editor_Collapse_Position_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_collapse_position_style = /** @type {((inputs?: Options_Editor_Collapse_Position_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Collapse_Position_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position de réduction et style de légende")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position und Bildunterschriftenstil einklappen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione di compressione e stile della didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свернуть положение и стиль подписи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición de colapso y estilo de leyenda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("折叠位置和标题样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("折りたたみ位置とキャプションスタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति और कैप्शन शैली को संक्षिप्त करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição de recolhimento e estilo da legenda")
	return /** @type {LocalizedString} */ ("Collapse Position and Caption Style")
});